import React, { createContext, useContext, useRef } from 'react';
/**
 * This context maintains a list of all media players on the current page.
 */
export const MediaPlayerContext = createContext({
    mediaPlayers: [],
});
/**
 * Implementation of a stateful MediaPlayerContext provider
 */
export const MediaPlayerContextProvider = ({ children }) => {
    const value = useRef({
        mediaPlayers: [],
    });
    return (React.createElement(MediaPlayerContext.Provider, { value: value.current }, children));
};
/**
 * Convenience hook
 */
export const useMediaPlayer = () => useContext(MediaPlayerContext);
